import { Component, Output, Input, EventEmitter } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { CustomerProvider } from '../../providers/customer/customer';
import { APP_CONFIG } from '../../environment';
import { USER_FEATURES, LANGUAGES } from '../../providers/myria/app-variables';
import { LoginProvider } from '../../providers/myria/login-provider';
import { HttpProvider } from '../../providers/http/http';
import { brandings } from '../../environment/branding/brandings'
import { UtilsProvider } from '../../providers/myria/utils-provider';

@Component({
  selector: 'rmt-language',
  templateUrl: 'rmt-language.html'
})
export class RmtLanguageComponent {
  @Output() ionChange = new EventEmitter<string>();
  @Input() showSelectedValue: boolean = true;
  @Input() showSelectedValueText: boolean = false;
  @Input() showDropdownCaret: boolean = false;
  @Input() langBtnId;
  selectedIcon = 'custom-icon-country-us';
  selectedValue = 'EN';
  selectedValueText = 'English (US)'
  items;
  langs;
  itemSelected;
  handleDismiss;

  constructor(private modal: ModalController,
              private customerProvider: CustomerProvider,
              private contentProvider: TranslateService,
              private loginProvider: LoginProvider,
              private utilsProvider: UtilsProvider) {    
  }

  ngAfterViewInit() {
    if (!this.items)
      this.update();
  }

  setValue(value) {
    const item = this.items.find((item) => (item.value === value));
    if (item)
      this.setItem(item);
  }

  private setItem(item) {

    this.selectedValue = item.visibleValue;
    this.selectedValueText = item.text;
    
    if(item.isSelected === true){
      this.itemSelected = item;
      this.selectedIcon = item.icon;
    }
  }

  async showPicker() {
    await this.update(false);

    const params = {
      header: this.contentProvider.instant('page.languagePage.title'),
      placeholder: this.contentProvider.instant('page.languagePage.languageSearch'),
      useIcons: true,
      items: this.items,
      itemSelected: this.itemSelected

    };
    const modal = this.modal.create('SelectPickerPage', params, { cssClass: 'modal-default' });
    modal.onDidDismiss((item) => {
      if (item && item.value) {
        this.setItem(item);
        this.ionChange.emit(item.value);
        // Lite users only carry ReservedCustomerId; the login no longer saves the phone language for them.
        if (HttpProvider.hasAuthCustomerId(null, true))
          this.loginProvider.updateSetting(USER_FEATURES.LANGUAGE.AREA, USER_FEATURES.LANGUAGE.TYPE, item.value).subscribe();
      }

      if(this.handleDismiss){
        this.handleDismiss(item.value);
      }

    });

    modal.present();
    return false;
  }

  async update(setValue: boolean = true) {
    const language = await this.customerProvider.getCurrentLanguage();
    let availableLangs = LANGUAGES;
    this.items = [];

    for (const lang in availableLangs) {
      if (APP_CONFIG.branding === brandings.Walmart && lang === 'vi-US') // skip vietnamese for Walmart
      continue;
      this.items.push(LANGUAGES[lang]);
    }
    if (setValue && language) 
      this.setValue(language);
    if (language)
      this.itemSelected = LANGUAGES[language]
    
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-language/rmt-language.ts